import { TopicData } from "./schema";

export function idForClip(): string {
  return crypto.randomUUID();
}

export function idForSeries(): string {
  return crypto.randomUUID();
}

export function idForMap(data: TopicData[]): string {
  if (data.length > 0) {
    return data
      .map((d) => `${d.topic.name}:${d.messagePath.dotPath}`)
      .sort()
      .join("-");
  } else {
    return "Map";
  }
}
